import type { PlaceStatus } from '@antoja/shared';
import { t } from '../i18n';

export function statusLabel(status: PlaceStatus): string {
  return t(`placeStatus.${status}`);
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('es-CO', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso));
}

/** 28000 → "$28.000", 9000 → "$9.000": one price format across the console. */
export function formatPrice(price: number): string {
  return `$${String(Math.round(price)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
}
